module.exports = __webpack_public_path__ + "img/img-today-total2.58eae0a2.png";